import { ApiError } from '@scoreboard/api-client';
import type { TFunction } from 'i18next';

// Le serveur renvoie un code machine (doc 02 §1.5) ; c'est le client qui traduit.
// Un code inconnu retombe sur le message générique du doc 05 §7 — jamais « Oups ».

export function errorMessage(t: TFunction, error: unknown): string {
  const code = error instanceof ApiError ? error.code : null;
  if (code === null) {
    return t('errors.generic');
  }
  const key = `errors.${code}`;
  const translated = t(key);
  return translated === key ? t('errors.generic') : translated;
}
